import { render, staticRenderFns } from "./Co_Materials_and_Finishes.vue?vue&type=template&id=51c9ddd5&scoped=true"
import script from "./Co_Materials_and_Finishes.vue?vue&type=script&setup=true&lang=js"
export * from "./Co_Materials_and_Finishes.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Co_Materials_and_Finishes.vue?vue&type=style&index=0&id=51c9ddd5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c9ddd5",
  null
  
)

export default component.exports